import angular from 'angular';
import _ from 'lodash';
import $ from 'jquery';

'use strict';

const directiveModule = angular.module('tinaba.directives.googleAutocomplete', [])
	.directive('googleAutocomplete', function ($window, $log, API_KEY_GOOGLE, MerchantConfigurationService, $timeout) {
        'ngInject';		
		return {
			restrict: 'A',
			scope: {
				address: '<',
				returnAddress: '='
			},
			link: function (scope, element) {
				let autocomplete;

				const fieldsMap = {
					'route': {
						rename: 'street',
						pick: 'long_name'
					},
					'street_number': {
						rename: 'nr',
						pick: 'long_name'
					},
					'locality': {
						rename: 'city',
						pick: 'long_name'
					},
					'locality': {
						rename: 'city',
						pick: 'long_name'
					},
					'administrative_area_level_2': {
						rename: 'province',
						pick: 'short_name'
					},
					'postal_code': {
						rename: 'zip',
						pick: 'long_name'
					},
					'country': {
						rename: 'nazione',
						pick: 'short_name'
					}
				};

				const lazyLoad = () => {
					element[0].placeholder ="Inserisci una posizione";					
					let s = document.createElement("script");
					s.src = `https://maps.googleapis.com/maps/api/js?key=${API_KEY_GOOGLE}&libraries=places&callback=initMapsAutocomplete`;
					s.setAttribute("id", "google-script");
					element[0].appendChild(s);
					$timeout(() => {
						const newElement = document.getElementsByClassName("pac-container pac-logo hdpi");
						if (newElement[0] !== null && newElement[0] !== undefined) newElement[0].classList.add("lista-google");			
						$(newElement[0]).insertAfter("#google-input");
					}, 1000);

				};

				const clearObject = () => {
					if(scope.returnAddress){
						scope.returnAddress.city = '';
						scope.returnAddress.street = '';
						scope.returnAddress.nazione = '';
						scope.returnAddress.nr = '';
						scope.returnAddress.zip = '';
						scope.returnAddress.province = '';
					}else{
						scope.returnAddress = {}
					}				
				};

				const fillInAddress = () => {
					clearObject();
					let place = autocomplete.getPlace();
					$log.debug("place autocomplete", place);
					scope.returnAddress.fullAddress = place.formatted_address;
					_.forEach(place.address_components, (component) => {
						if (fieldsMap.hasOwnProperty(component.types[0])) {
							const field = fieldsMap[component.types[0]];
							scope.returnAddress[field.rename] = component[field.pick];
						}
					});
					if (scope.returnAddress.street === '' && scope.returnAddress.nr === '' && scope.returnAddress.city === '' && scope.returnAddress.zip === '' &&  scope.returnAddress.province === '' && scope.returnAddress.nazione === '') {
						return;
					}
					MerchantConfigurationService.getCoordsByAddress(scope.returnAddress.street, scope.returnAddress.nr, scope.returnAddress.city, scope.returnAddress.zip, scope.returnAddress.province, scope.returnAddress.nazione, true).then(response => {
						scope.returnAddress.longitudine = response.longitude;
						scope.returnAddress.latitudine = response.latitude;
					}, error => {
						$log.error("Errore nel recupero delle coordinate", error);
					});
					//TODO: chiamare servizio geocode con formatted address e aggiungere a returnAddress latitudine  elongitudine
				};

				const displaySuggestions = (predictions, status) => {
					if (status != google.maps.places.PlacesServiceStatus.OK) {
						alert(status);
						return;
					}

					$log.debug("predizioni", predictions);
				};

				this.init = () => {
					$log.debug("abbiamo maps");
					element[0].setAttribute("id", "google-input");
					const oldElement = document.getElementById("google-script")
					if (oldElement !== null) oldElement.remove();
					const lastElement = document.getElementsByClassName("pac-container pac-logo hdpi lista-google");
					if (lastElement[0] !== null && lastElement[0] !== undefined) lastElement[0].remove();
					lazyLoad();
				};

				this.updateSearch = () => {
					autocomplete.getPlacePredictions({
						input: this.luogo
					}, displaySuggestions);
				};

				$window.initMapsAutocomplete = () => {
					$log.debug("INIT MAPS DONE");
					autocomplete = new google.maps.places.Autocomplete(element[0], {
						types: ['address']
					});
					autocomplete.setComponentRestrictions({
						'country': ['it']
					});
					autocomplete.addListener('place_changed', fillInAddress);
					
					if (navigator.userAgent.match(/(iPad|iPhone|iPod)/g)) {
						setTimeout(function() {
							let container = document.getElementsByClassName('pac-container')[0];
							container.addEventListener('touchend', function(e) {
								e.stopImmediatePropagation();
							});
						}, 500);
					}
				};

				this.init();
			}
		};
	});

export default directiveModule;


/** WEBPACK FOOTER **
 ** ./client/app/common/directives/googleAutocomplete.js
 **/